var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.template.cell
    ? _c(
        "td",
        {
          staticClass: "questionnaireTableCellQuestion",
          class: _vm.classes,
          attrs: { rowspan: _vm.rowSpan, colspan: _vm.colSpan },
        },
        [
          _c(
            "div",
            {
              staticClass: "questionnaireTableCellInputContainer",
              class: _vm.classesForInputContainer,
            },
            [
              _c("input", {
                staticClass: "questionnaireTableCellInput",
                attrs: {
                  id: _vm.template.cell.id,
                  type: "text",
                  readonly: "readonly",
                  name: _vm.template.cell.id,
                  placeholder: _vm.template.cell.placeholder,
                },
                domProps: { value: _vm.answer },
              }),
              _c("tooltip", {
                attrs: {
                  ord: _vm.template.cell.ord,
                  title: _vm.template.cell.name,
                  description: _vm.template.cell.description,
                  required: _vm.isRequired,
                },
              }),
            ],
            1
          ),
        ]
      )
    : _c(
        "td",
        {
          staticClass: "questionnaireTableCellLabel",
          class: _vm.classes,
          attrs: { rowspan: _vm.rowSpan, colspan: _vm.colSpan },
        },
        [_vm._v(" " + _vm._s(_vm.template.name) + " ")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }